import React from 'react'
import _ from 'lodash'
import I18n from '../lib/i18n'
import formatCurrency from '../helpers/formatCurrency'
import BottomSheetSelectList from './BottomSheetSelectList'
// import ColorOptionLabel from './ColorOptionLabel'
import IconTick from '../images/icon_tick.svg'

const SizesList = (props, context) => {
  const shades_list = _.map(props.options, sku => {
    const _isSelected = (id) => props.selected === id
    const { size_option = {}, sell_price = '', stock_level = 0} = sku
    const { id = '' } = size_option
    const disabled = stock_level === 0
    const handleClick = disabled ? null : props.onSelect.bind(this, size_option)
    return <div
      key={`size-${id}`}
      className={`item ${_isSelected(id) ? 'selected-item' : ''} ${disabled ? 'disabled' : ''}`}
      onClick={handleClick}
    >
      <div className='item-container'>
        <div className='size-label'>{`${size_option.name} - ${formatCurrency(sell_price)}`}</div>
        {
          props.selected === id &&
            <img className='tick' alt='' src={IconTick} />
        }
      </div>
    </div>
  })

  return <BottomSheetSelectList
    title={I18n.t('sizes_list.title')}
    list={shades_list}
    onClose={props.onClose}
  />
}

export default SizesList



// WEBPACK FOOTER //
// ./src/components/SizesList.js